export function resolveSelectedWaist(options) {
    const { value } = options.find((option) => option.selected);
    return value.split('/')[0];
  }